import React, { FC } from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import { ImageProps } from 'frontastic/lib/image';
import PaymentCards from '/public/images/payment-cards.svg';
import { SocialMedia } from './types';

interface Props {
  logo?: ImageProps;
  socialMedia?: SocialMedia[];
}

const FooterBottom: FC<Props> = ({ logo, socialMedia }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const YEAR = new Date().getFullYear();
  return (
    <div className="flex w-full items-center justify-center bg-white">
      <div className="w-full max-w-[1300px] items-center justify-between bg-white px-15 py-10 md:flex">
        <div className="mx-auto flex w-full items-center">
          <div className="flex w-full items-center justify-between">
            <div className="flex-7">
              <p className="hidden py-15 text-13 font-semibold leading-[20px] text-neutral-600 md:flex">
                {`\u00A9`}
                {formatMessage({
                  id: 'copyright',
                  defaultMessage: ` Copyright`,
                })}
                {` ${YEAR} `}
                {formatMessage({
                  id: 'registration',
                  defaultMessage: `AMERICAN GOLF (TRADING) LIMITED - Company Registration no: 11282323 - VAT Registered: GB 308 9204 06`,
                })}
              </p>
              <p className="px-10 py-12 text-center text-14 font-semibold leading-[20px] text-neutral-600 md:hidden">
                {`\u00A9`}
                {formatMessage({
                  id: 'copyright',
                  defaultMessage: ` Copyright`,
                })}
                {` ${YEAR} `}
                {formatMessage({
                  id: 'americanGolf',
                  defaultMessage: `AMERICAN GOLF (TRADING) LIMITED`,
                })}
              </p>
            </div>
            <div className="hidden w-[370px] flex-4 py-15 text-14 font-normal leading-[20px] md:block lg:ms-20">
              <PaymentCards />
            </div>
          </div>
        </div>
        {/* {logo && (
          <div className="w-160">
            <Image {...logo} alt="logo" />
          </div>
        )}
        <Typography className="text-14 text-neutral-500">
          {formatMessage({ id: 'powered', defaultMessage: 'Powered by commercetools' })}
        </Typography>
        <ul className="flex flex-row gap-20 self-center">
          {socialMedia?.map((item, i) => (
            <li key={i} className="w-22">
              <Link link={item.reference}>
                <Image {...item.logo} className="mb-20" />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex flex-col items-center py-32 md:hidden">
        <ul className="mb-20 flex flex-row gap-20 self-center">
          {socialMedia?.map((item, i) => (
            <li key={i} className="w-22">
              <Link link={item.reference}>
                <Image {...item.logo} className="mb-16" />
              </Link>
            </li>
          ))}
        </ul>
        {logo && (
          <div className="mb-16 w-190">
            <Image {...logo} alt="logo" />
          </div>
        )}
        <Typography className="text-14 text-neutral-500">
          {formatMessage({ id: 'powered', defaultMessage: 'Powered by commercetools' })}
        </Typography> */}
      </div>
    </div>
  );
};

export default FooterBottom;
